<template>
  <div class="hidden h-10 w-96 items-center justify-between md:flex">
    <input
      type="search"
      class="dark:bg-ontick-graphite-500 border-ontick-steel-300 h-full w-full rounded-l-lg border-2 bg-transparent dark:border-none dark:placeholder-gray-300"
      :value="value"
      @input="$emit('input', $event.target.value)"
      placeholder="Buscar"
      id="new-password"
      name="new-password"
      autocomplete="new-password"
      autocapitalize="off"
      autocorrect="off"
      autofocus=""
      role="combobox"
      spellcheck="false"
    />
    <div
      class="dark:bg-ontick-graphite-500 border-ontick-steel-300 text-ontick-steel-400 flex h-full items-center justify-center rounded-r-lg border-2 border-l-0 bg-transparent px-2 dark:border-none dark:text-gray-300"
    >
      <i
        v-html="loading ? $icons.loading : $icons.search"
        :class="{ 'text-ontick-blue-600': loading }"
      ></i>
      <label class="sr-only" for="new-password"> Buscar </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    },
    loading: {
      type: Boolean,
    },
  },
};
</script>

<style></style>
